import { Button, ButtonProps } from '@v2/components/ui/button';
import { cn } from '@v2/lib/utils';

export const ButtonInGroup = ({
  children,
  isAlone,
  ...props
}: ButtonProps & { isAlone?: boolean }) => {
  return (
    <Button
      {...props}
      className={cn(
        'h-10',
        'mx-0 gap-0',
        'bg-background',
        'p-1',
        'border-input border-y md:border-x-0',
        'rounded-v2',
        'first:rounded-v2-l first:rounded-r-none first:border-r-0 first:border-l',
        !isAlone &&
          'last:rounded-v2-r last:rounded-l-none last:border-r-1 last:border-l-0',
        'not-last:border-r-0 not-first:border-l-0',
        'group/btn-in-group',
        !props.disabled && 'hover:border-neutral-200 hover:bg-background',
        props.className
      )}
      variant="outline"
      size="sm"
    >
      <span
        className={cn(
          'flex h-full w-full items-center justify-center',
          'flex items-center justify-center',
          'bg-transparent transition-colors',
          'rounded-lg',
          !props.disabled && 'group-hover/btn-in-group:bg-neutral-50'
        )}
      >
        {children}
      </span>
    </Button>
  );
};
